import {otsBaseApi} from "../ots-api";
import {HeatmapGrid, HeatmapGridRequest} from "../../model/heatmap";

const ALL_TAG_TYPES = [] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const heatmapApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHeatmapGrid: builder.query<HeatmapGrid, HeatmapGridRequest>({
      query: (arg) => ({
        url: `/heatmap/grid`,
        method: "POST",
        body: arg
      }),
    }),
  })
});

export const {
  useGetHeatmapGridQuery,
  useLazyGetHeatmapGridQuery,
} = heatmapApi;
